/* ============================================================
   GOLDEN TECH · ESCANER  ·  GR 1.1
   Cabeza robotica levantada por formula (sin modelo 3D, sin libreria)
   y MAPEADA por un plano de laser rojo que la recorre de arriba abajo.
   GR 1.1: coronilla achatada, mandibula en punta, y un VISOR corrido
   de lado a lado, que es lo que hace que el ojo lea "robot" y no "bola".
   ============================================================ */
(function () {
  "use strict";

  var QUIETO = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function escaner(lienzo) {
    if (!lienzo || !lienzo.getContext || lienzo.dataset.gtListo === "1") return;
    lienzo.dataset.gtListo = "1";
    var ctx = lienzo.getContext("2d");
    if (!ctx) return;

    var GIRO      = parseFloat(lienzo.dataset.giro);
    var BARRIDO   = parseFloat(lienzo.dataset.barrido);
    var DENSIDAD  = parseInt(lienzo.dataset.densidad, 10);
    var PARALAJE  = parseFloat(lienzo.dataset.paralaje);
    var HORIZONTE = lienzo.dataset.horizonte !== "0";
    if (isNaN(GIRO))     GIRO = 0.18;
    if (isNaN(BARRIDO))  BARRIDO = 7;
    if (isNaN(DENSIDAD)) DENSIDAD = 2;
    if (isNaN(PARALAJE)) PARALAJE = 0.35;

    var ROJO  = lienzo.dataset.rojoRgb  || "255,59,59";
    var FONDO = lienzo.dataset.fondoRgb || "4,4,10";

    var LAT = [16, 24, 32][DENSIDAD - 1] || 24;
    var LON = [28, 44, 60][DENSIDAD - 1] || 44;

    var vertices = [];
    var malla = [];
    var rejilla = [];

    function suave(b, x) { var t = Math.min(1, Math.max(0, x / b)); return t * t * (3 - 2 * t); }

    function punto(fila, col) {
      var v = Math.PI * (fila / LAT);
      var u = 2 * Math.PI * (col / LON);
      var sv = Math.sin(v), cv = Math.cos(v);
      var su = Math.sin(u), cu = Math.cos(u);

      var r = 1;
      var frente = Math.max(0, cu);
      var tipo = 0;

      if (v < 0.38) r *= 1 - 0.13 * (1 - v / 0.38);

      var mand = suave(1, (v - 1.60) / 0.90);
      r *= 1 - 0.46 * mand;

      r *= 1 - 0.20 * Math.max(0, -cu);

      var ceja = suave(1, 1 - Math.abs(v - 0.90) / 0.11) * frente;
      r += 0.10 * ceja;

      var visorV = suave(1, 1 - Math.abs(v - 1.07) / 0.11);
      var visor = visorV * (cu > 0.24 ? 1 : 0);
      if (visor > 0.42) { tipo = 1; }
      r -= 0.14 * visor;

      var enRejV = suave(1, 1 - Math.abs(v - 1.66) / 0.09);
      var rej = enRejV * (cu > 0.55 ? 1 : 0);
      if (rej > 0.4 && (col % 2 === 0)) { tipo = 2; }
      r -= 0.05 * rej;

      return {
        x: r * sv * cu * 0.86,
        y: -r * cv * 1.16 + 0.06,
        z: r * sv * su * 0.90,
        tipo: tipo
      };
    }

    (function construir() {
      var f, c, f2, c2;
      for (f = 0; f <= LAT; f++) {
        rejilla[f] = [];
        for (c = 0; c < LON; c++) {
          rejilla[f][c] = vertices.length;
          vertices.push(punto(f, c));
        }
      }
      for (f2 = 0; f2 <= LAT; f2++) {
        for (c2 = 0; c2 < LON; c2++) {
          malla.push([rejilla[f2][c2], rejilla[f2][(c2 + 1) % LON]]);
          if (f2 < LAT && c2 % 2 === 0) malla.push([rejilla[f2][c2], rejilla[f2 + 1][c2]]);
        }
      }
    })();

    var an = 0, al = 0, dpr = 1, cx = 0, cy = 0, escala = 1;
    var corriendo = false, lazo = 0, t0 = 0, ang = 0, barrido = -1.25;
    var ratonX = 0, ratonY = 0, sigueX = 0, sigueY = 0;
    var proy = [];

    function medir() {
      dpr = Math.min(window.devicePixelRatio || 1, 2);
      an = lienzo.clientWidth; al = lienzo.clientHeight;
      if (an === 0 || al === 0) return false;
      lienzo.width = Math.round(an * dpr);
      lienzo.height = Math.round(al * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      cx = an / 2;
      cy = al * 0.46;
      escala = Math.min(an, al) * 0.30;
      return true;
    }

    function pintarHorizonte() {
      if (!HORIZONTE) return;
      var hy = al * 0.78;
      var i, j, p, y;
      ctx.save();
      ctx.strokeStyle = "rgba(" + ROJO + ",0.13)";
      ctx.lineWidth = 1;
      for (i = -9; i <= 9; i++) {
        ctx.beginPath();
        ctx.moveTo(cx + i * (an / 6), al);
        ctx.lineTo(cx + i * 14, hy);
        ctx.stroke();
      }
      for (j = 1; j <= 14; j++) {
        p = j / 14;
        y = hy + (al - hy) * (p * p);
        ctx.globalAlpha = 0.5 * (1 - p) + 0.12;
        ctx.beginPath();
        ctx.moveTo(0, y);
        ctx.lineTo(an, y);
        ctx.stroke();
      }
      ctx.restore();
    }

    function pintar(dt) {
      ctx.fillStyle = "rgba(" + FONDO + ",0.30)";
      ctx.fillRect(0, 0, an, al);

      pintarHorizonte();

      sigueX += (ratonX - sigueX) * 0.06;
      sigueY += (ratonY - sigueY) * 0.06;

      ang += GIRO * dt;
      var giro = ang + sigueX * PARALAJE;
      var incl = -0.10 + sigueY * PARALAJE * 0.45;

      var sg = Math.sin(giro), cg = Math.cos(giro);
      var si = Math.sin(incl), ci = Math.cos(incl);

      barrido += (BARRIDO / 60) * dt * 2.7;
      if (barrido > 1.35) barrido = -1.35;

      var i, v, x1, z1, y2, z2, k;
      for (i = 0; i < vertices.length; i++) {
        v = vertices[i];
        x1 = v.x * cg + v.z * sg;
        z1 = -v.x * sg + v.z * cg;
        y2 = v.y * ci - z1 * si;
        z2 = v.y * si + z1 * ci;
        k = 3.1 / (3.1 + z2);
        proy[i] = {
          sx: cx + x1 * escala * k,
          sy: cy + y2 * escala * k,
          k: k,
          z: z2,
          d: Math.abs(v.y - barrido),
          tipo: v.tipo
        };
      }

      var a, b, cerca, alfa, prof, enLaser;
      ctx.lineCap = "round";
      for (i = 0; i < malla.length; i++) {
        a = proy[malla[i][0]];
        b = proy[malla[i][1]];
        if (a.z > 0.92 && b.z > 0.92) continue;
        cerca = Math.min(a.d, b.d);
        enLaser = cerca < 0.09;
        prof = 1 - (a.z + 1.30) / 2.60;
        prof = Math.min(1, Math.max(0.06, prof));

        if (enLaser) {
          ctx.strokeStyle = "rgba(255,225,225,0.95)";
          ctx.lineWidth = 1.5;
          ctx.shadowColor = "rgba(" + ROJO + ",0.95)";
          ctx.shadowBlur = 12;
        } else {
          alfa = (0.04 + prof * prof * 0.40) * (cerca < 0.42 ? 1.8 : 1);
          ctx.strokeStyle = "rgba(" + ROJO + "," + Math.min(0.55, alfa).toFixed(3) + ")";
          ctx.lineWidth = 0.7 + prof * 0.5;
          ctx.shadowBlur = 0;
        }
        ctx.beginPath();
        ctx.moveTo(a.sx, a.sy);
        ctx.lineTo(b.sx, b.sy);
        ctx.stroke();
      }
      ctx.shadowBlur = 0;

      var r, brillo;
      for (i = 0; i < proy.length; i++) {
        a = proy[i];
        if (a.z > 0.92) continue;
        if (a.tipo === 0 && a.d > 0.10) continue;
        r = a.tipo === 1 ? 2.2 : (a.tipo === 2 ? 1.5 : 1.2);
        brillo = a.tipo === 1 ? 0.92 : (a.d < 0.09 ? 0.85 : 0.45);
        ctx.fillStyle = a.tipo === 1
          ? "rgba(255,240,240," + brillo + ")"
          : "rgba(" + ROJO + "," + brillo + ")";
        ctx.shadowColor = "rgba(" + ROJO + ",0.9)";
        ctx.shadowBlur = a.tipo === 1 ? 16 : 8;
        ctx.beginPath();
        ctx.arc(a.sx, a.sy, r * a.k, 0, 6.2832);
        ctx.fill();
      }
      ctx.shadowBlur = 0;

      var ly = cy + (barrido * ci) * escala;
      var grad = ctx.createLinearGradient(0, 0, an, 0);
      grad.addColorStop(0, "rgba(" + ROJO + ",0)");
      grad.addColorStop(0.5, "rgba(" + ROJO + ",0.55)");
      grad.addColorStop(1, "rgba(" + ROJO + ",0)");
      ctx.strokeStyle = grad;
      ctx.lineWidth = 1;
      ctx.beginPath();
      ctx.moveTo(0, ly);
      ctx.lineTo(an, ly);
      ctx.stroke();
    }

    function fotograma(ahora) {
      if (!corriendo) return;
      var dt = Math.min(0.05, (ahora - t0) / 1000) || 0.016;
      t0 = ahora;
      pintar(dt);
      lazo = window.requestAnimationFrame(fotograma);
    }

    function arrancar() {
      if (corriendo || QUIETO) return;
      corriendo = true;
      t0 = performance.now();
      lazo = window.requestAnimationFrame(fotograma);
    }
    function parar() { corriendo = false; if (lazo) window.cancelAnimationFrame(lazo); }

    function iniciar() {
      if (!medir()) return;
      ctx.fillStyle = "rgb(" + FONDO + ")";
      ctx.fillRect(0, 0, an, al);
      pintar(0.016);
      if (!QUIETO) arrancar();
    }

    if (window.IntersectionObserver) {
      new IntersectionObserver(function (filas) {
        filas[0].isIntersecting ? arrancar() : parar();
      }, { threshold: 0 }).observe(lienzo);
    }
    document.addEventListener("visibilitychange", function () { document.hidden ? parar() : arrancar(); });

    if (window.matchMedia && window.matchMedia("(hover:hover)").matches) {
      window.addEventListener("mousemove", function (ev) {
        ratonX = (ev.clientX / window.innerWidth - 0.5) * 2;
        ratonY = (ev.clientY / window.innerHeight - 0.5) * 2;
      }, { passive: true });
    }

    var espera = 0;
    window.addEventListener("resize", function () {
      clearTimeout(espera);
      espera = setTimeout(function () { parar(); iniciar(); }, 180);
    });

    iniciar();
    if (an === 0) window.setTimeout(iniciar, 300);
  }

  function arrancarTodo() {
    var l = document.querySelectorAll("[data-gt-robot]");
    for (var i = 0; i < l.length; i++) escaner(l[i]);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", arrancarTodo);
  else arrancarTodo();
  document.addEventListener("shopify:section:load", arrancarTodo);
})();
